import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from "recharts";
import { Spinner } from 'react-bootstrap';

const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", '#14522f'];

const CustomTooltip = ({active, payload, label}) => {

    if (payload && payload.length) {
        // debugger;

      return (
        <div className="custom-tooltip">
          <div>{payload[0].payload.fullname} ({payload[0].payload.name})</div>
        </div>
      );
    }
  
    return null;
  };

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
    index
}) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
        <text
            x={x}
            y={y}
            fill="white"
            textAnchor={x > cx ? "start" : "end"}
            dominantBaseline="central"
        >
            {`${(percent * 100).toFixed(0)}%`}
        </text>
    );
};

const CustomSpinner = () => {
    return (
        <>
            <div className='col-md-6 col-xs-12 col-lg-4 col-sm-12'>
                <div className="card">
                    <div className="card-header blue-heading">
                        Top Character Count By Customer
                    </div>
                    <div className="card-body search-form">
                        <MySpinner />
                        <div style={{ width: '100%' }} className='set-height'></div>
                    </div>
                </div>
            </div>
        </>
    )
}

const MySpinner = () => {
    return (
        <Spinner className='spinner-border spinner-border-chart' />
    )
}

const RenderChart = ({data}) => {

    let rows = [];
    data.map((row) => {
        const newRow = {
            "name": row.customerShortName,
            "fullname": row.customerName,
            value: row.totalCharacter
        }
        rows = [...rows, newRow]
    });

    return (
        <>
            <div className='col-md-6 col-xs-12 col-lg-4 col-sm-12'>
                <div className="card">
                    <div className="card-header blue-heading">
                        Top Character Count By Customer
                    </div>
                    <div className="card-body search-form" id='count-by-customer'>
                        <div style={{ width: '100%' }} className='set-height'>
                            <ResponsiveContainer>
                                <PieChart width={400} height={200}>
                                    <Pie
                                        data={rows}
                                        labelLine={false}
                                        label={renderCustomizedLabel}
                                        // outerRadius={50}
                                        fill="#8884d8"
                                        dataKey="value"
                                    >
                                        {data.map((entry, index) => (
                                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                        ))}
                                    </Pie>
                                    <Tooltip content={<CustomTooltip />} />
                                    <Legend
                                        wrapperStyle={{ marginTop: '3px' }}
                                        iconSize={5}
                                        fontSize={10}
                                    />
                                </PieChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default function TopCustomersByCharacterCount({ data, loading }) {
    if(loading){
        return <CustomSpinner />
    }

    return <RenderChart data={data} />
}